import { render } from "./discountsMenu.vue?vue&type=template&id=5e62112d"
import script from "./discountsMenu.vue?vue&type=script&lang=js"
export * from "./discountsMenu.vue?vue&type=script&lang=js"

import "./discountsMenu.vue?vue&type=style&index=0&id=5e62112d&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__